import { useSelector } from "react-redux";
import { Permission } from "src/models";
import { selectCurrentPermissions } from "src/store/reducers/auth/authSlice";

export const usePermissions = () => {
  const permissions: Permission[] = useSelector(selectCurrentPermissions) ?? [];

  const hasPermissions = (action: string, subject: string) =>
    permissions.some((p) => p.action === action && p.subject === subject);

  return { hasPermissions };
};
